import { render } from "./LeafletPoiDetail.vue?vue&type=template&id=63cb04f8&scoped=true"
import script from "./LeafletPoiDetail.vue?vue&type=script&lang=ts"
export * from "./LeafletPoiDetail.vue?vue&type=script&lang=ts"

import "./LeafletPoiDetail.vue?vue&type=style&index=0&id=63cb04f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63cb04f8"

export default script